import { styled, TableRow as MuiTableRow } from "@mui/material";
import {
  sapphire,
  jordyBlue,
  dodgerBlue,
  linkWater,
  gainsboro,
  white,
  deYork,
} from "shared/assets/colors";

const PREFIX = "ClientDocumentTableRowStyles";
export const classes = {
  cell: `${PREFIX}-cell`,
  center: `${PREFIX}-center`,
  typographyValue: `${PREFIX}-typographyValue`,
  typographyLink: `${PREFIX}-typographyLink`,
  typographyLabel: `${PREFIX}-typographyLabel`,
  buttonIcon: `${PREFIX}-buttonIcon`,
  chip: `${PREFIX}-chip`,
  greenChip: `${PREFIX}-greenChip`,
};

export const TableRow = styled(MuiTableRow)(() => ({
  [`& .${classes.cell}`]: {
    border: `1px solid ${gainsboro}`,
  },
  [`& .${classes.center}`]: {
    display: "flex",
    justifyContent: "center",
  },
  [`& .${classes.typographyValue}`]: {
    color: sapphire,
  },
  [`& .${classes.typographyLink}`]: {
    textDecoration: "none",
  },
  [`& .${classes.typographyLabel}`]: {
    color: linkWater,
  },
  [`& .${classes.buttonIcon}`]: {
    color: jordyBlue,
    "&:hover": {
      color: dodgerBlue,
    },
  },
  [`& .${classes.chip}`]: {
    maxWidth: 90,
    maxHeight: 20,
    fontSize: 10,
  },
  [`& .${classes.greenChip}`]: {
    backgroundColor: deYork,
    color: white,
  },
}));
